"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MenuDivider: function() {
        return _index.MenuDivider;
    },
    menuDividerClassNames: function() {
        return _index.menuDividerClassNames;
    },
    renderMenuDivider_unstable: function() {
        return _index.renderMenuDivider_unstable;
    },
    useMenuDividerStyles_unstable: function() {
        return _index.useMenuDividerStyles_unstable;
    },
    useMenuDivider_unstable: function() {
        return _index.useMenuDivider_unstable;
    }
});
const _index = require("./components/MenuDivider/index");
